import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CommonComponentsModule } from '../../../../../../../SUVO-CORE-CLIENT-LIB/projects/suvo-core-client-lib/src/lib/features/common-components/common-components.module';
import { SharedModule } from '../../shared/shared.module';
import { ToggleGroupNavigationComponent } from './components/toggle-group-navigation/toggle-group-navigation.component';

@NgModule({
  imports: [CommonModule, SharedModule, CommonComponentsModule],
  declarations: [ToggleGroupNavigationComponent],
  exports: [ToggleGroupNavigationComponent],
})
export class ToggleGroupNavigationModule {}
